// test2532
(2532 && 0);
